<template>
  <div class="add-event-image">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <q-input
            square
            outlined
            label="Social Media Reference URL"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.Link"
            @update:model-value="(e) => fields.Link = e"
            @blur="v$.fields.Link.$touch()"
            :error="v$.fields.Link.$error"
            error-message="Ref Link is required"
          />

          <q-file
            square
            outlined
            v-model="image"
            label="Pick Image"
            @blur="v$.image.$touch()"
            :error="v$.image.$error"
            @update:model-value="handleUpload()"
            error-message="Image is required"
          />

          <div v-if="imageUrl">
            <q-img
              :src="imageUrl"
              spinner-color="white"
            />
          </div>
        <q-btn class="add-event-image-btn" label="Submit" @click="submit"/>
      </q-card-section>

    </q-card>

    <q-card class="my-card-edit">
      <q-card-section class="card-section">
        <div class="card-title">Edit Main Event</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <div class="col-item" v-for="(column, index) in eventImageColumn" :key="index">
          <main-event-image-list
            v-for="(imageEvent) in column"
            :key="imageEvent.ID"
            :mainEventImageInfo="imageEvent"
            @success-request="getInitialData"
          />
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
  <script>
  import MainEventImageList from './MainEventImageList.vue';
  import { mapActions, mapGetters } from 'vuex';
  import { required } from "vuelidate/lib/validators";
  import { useVuelidate } from '@vuelidate/core'
  
  export default {
    name: 'AddMainEventImage',
    components: {
      MainEventImageList
    },
    props: {
      module: {
        require: true,
        type: Object
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        fields: {
          Link: {
            required
          }
        },
        image: {
          required
        }
      }
    },
    data () {
      return {
        fields: {
          Link: null,
          image: null
        },
        imageUrl: null,
        image: null,
        column: 2
      }
    },
    computed: {
      ...mapGetters({
        getImageEvent: 'home/getImageEvent'
      }),
      eventImageColumn () {
        let column = []

        
        if (this.getImageEvent) {
          const eventImage = this.getImageEvent

          if (!eventImage) return []

          const mid = Math.ceil(eventImage.length / this.column)

          for (let col = 0; col < this.column; col++) {
            column.push(eventImage.slice(col * mid, col * mid + mid))
          }
        }

        return column
      }
    },
    methods: {
      ...mapActions({
        requestAddEventImage: 'home/requestAddEventImage',
        getInitialData: 'home/getInitialData'
      }),
      async handleUpload () {
        if (this.image) {
          this.imageUrl = URL.createObjectURL(this.image);
        }

        await this.createBase64Image(this.image)
      },
      async submit () {
        this.v$.fields.$touch();

        if (this.v$.fields.$invalid) {
          return
        }

        this.$q.loading.show();
        
        await this.recaptchaLoad('addeventimage')
  
        await this.requestAddEventImage(this.fields)
          .then(async response => {

            this.resetFields()
            await this.recaptchaLoad('addeventimage')

            this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })
  
            this.$q.loading.hide()
          })
          .catch((error) => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
          })
      },
      createBase64Image: function(FileObject) {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.fields.image = event.target.result;
        }

        reader.readAsDataURL(FileObject);
      },
      resetFields() {
        this.v$.fields.$reset()
        this.v$.image.$reset()

        this.fields = {
          ImageUrl: null,
          image: null
        }
        this.image = null
        this.imageUrl = null
      }
  }
}
</script>
<style lang="scss">
.add-event-image {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .add-event-image-btn {
      background-color: #FFC108;
    }
  }

  .my-card-edit {
    background-color: $backgroundHeader;
    margin-top: 16px;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }
    
    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: flex;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>